<template>
  <div class="uni-circle-progress">
    <div class="progress-circle">
      <el-tooltip
        class="item"
        effect="dark"
        :content="`${datas.title}(${datas.current}/${datas.total})`"
        placement="top-start"
      >
        <div class="title-box">
          <span class="tit">{{ datas.title }}</span>
          (<span class="primary">{{ datas.current }}</span
          >/<span>{{ datas.total || 0 }}</span
          >)
        </div>
      </el-tooltip>
      <span class="hr"></span>
    </div>

    <div class="progress-box">
      <el-progress
        :strokeWidth="4"
        type="circle"
        :width="progressWidth"
        :percentage="datas.percent"
        :color="color"
      ></el-progress>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComponentCircleProgress",
  props: {
    // title标题
    title: {
      type: String,
      default: "我的学分",
    },
    color: {
      type: String,
      default: "#2F4ECC",
    },
    // 数据
    datas: {
      type: Object,
      default: () => ({
        title: "",
        total: 0,
        current: "",
        percent: 0,
      }),
    },
    progressWidth: {
      type: Number,
      default: 90,
    },
  },
};
</script>

<style lang="scss">
.uni-circle-progress {
  .el-progress__text {
    font-size: 24px !important;
  }
}
</style>

<style lang="scss" scoped>
.uni-circle-progress {
  width: 100%;
  height: 100%;

  .progress-circle {
    position: relative;
    margin-bottom: 20px;
    border-bottom: 1px solid $gray;

    .hr {
      position: absolute;
      bottom: -1px;
      left: 20px;
      width: 30px;
      border-bottom: 2px solid;
      @include borderColor("primary");
    }
  }

  .title-box {
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    color: $grayLight;
    @extend %ellipse;
    .tit {
      color: $textColor;
      font-size: 16px;
    }
    .primary {
      @include fontColor("primary");
    }
  }

  .progress-box {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
